<div class="global-modal-container">

  @if ((currentModal$ | ngrxPush).includes(modalEnum.Notifications)) {
    <app-shared-modal-content-projection
      (closeModalEvent)="onNotificationsClose()"
      [modalSize]="'large'">
      <app-notification-modal-container class="content">
      </app-notification-modal-container>
    </app-shared-modal-content-projection>
  }

  @if ((currentModal$ | ngrxPush).includes(modalEnum.SignOut)) {
    <app-shared-modal-content-projection
      (closeModalEvent)="onCloseSignOutModal()"
      [modalSize]="'medium'"
      [modalTitle]="'Sign Out'">
      <div class="content" id="sign-out-modal">
        <div class="description">
          <div class="header"><span>NOTE</span>You are about to sign out of Gallix.</div>
          <div>Ensure that all your changes have been saved before signing out.</div>
          <div>
            You will need to log in again and may be required to re-enter your credentials to access your account.
          </div>
          <span></span>
          <div>If you did not intend to sign out, you can cancel this action below.</div>
        </div>
        <div class="actions">
          <span></span>
          <app-shared-button
            (buttonClicked)="onCloseSignOutModal()">
            Cancel
          </app-shared-button>
          <app-shared-button
            (click)="onSignOutClick()"
            [fill]="true">
            Confirm
          </app-shared-button>
        </div>
      </div>
    </app-shared-modal-content-projection>
  }


  @if ((currentModal$ | ngrxPush).includes(modalEnum.ViewChanges)) {
    <app-shared-modal-content-projection
      (closeModalEvent)="closeInnerModal( modalEnum.Notifications)"
      [modalTitle]="(viewChangesModalTitle$ | ngrxPush) ?? 'View Changes'"
      class="sub-modal">
      <app-notification-type-stock-update-view-changes
        class="content">
      </app-notification-type-stock-update-view-changes>
    </app-shared-modal-content-projection>
  }

</div>
